/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type School from '@linc-technologies/linced-common/models/school';
import moment from 'moment';

// Proto: dates.Timeframe.
export default class Timeframe extends Model {
  declare [Type]: 'timeframe';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare columnLabel: string;

  @attr('string')
  declare startDate: string | undefined;

  @attr('string')
  declare endDate: string | undefined;

  @attr('string', { defaultValue: '' })
  declare year: string;

  @computed('startDate')
  get startDateUnix() {
    return moment(this.startDate, 'YYYY-MM-DD').unix();
  }

  @computed('endDate')
  get endDateUnix() {
    return moment(this.endDate, 'YYYY-MM-DD').add('1', 'day').unix();
  }

  @computed('startDateUnix', 'endDateUnix')
  get isCurrent() {
    const now = moment();
    return now.unix() >= this.startDateUnix && now.unix() <= this.endDateUnix;
  }
}
